import React from 'react';
import { ACHILLES_CUSTOMIZATION } from './services/customization.service';
import GenericDownloadPage from './generic-download-page';

function AchillesEfakturDownloadPage() {
  return <GenericDownloadPage pageDecorator={ACHILLES_CUSTOMIZATION} />;
}

export default AchillesEfakturDownloadPage;
